import { render, staticRenderFns } from "./commercial-new-proposal-button.vue?vue&type=template&id=2b5d55ec&"
import script from "./commercial-new-proposal-button.vue?vue&type=script&lang=js&"
export * from "./commercial-new-proposal-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5d55ec')) {
      api.createRecord('2b5d55ec', component.options)
    } else {
      api.reload('2b5d55ec', component.options)
    }
    module.hot.accept("./commercial-new-proposal-button.vue?vue&type=template&id=2b5d55ec&", function () {
      api.rerender('2b5d55ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/notices/partials/commercial-new-proposal-button.vue"
export default component.exports